import { render, staticRenderFns } from "./Regular.vue?vue&type=template&id=bfb07c60&"
import script from "./Regular.vue?vue&type=script&lang=js&"
export * from "./Regular.vue?vue&type=script&lang=js&"
import style0 from "./Regular.vue?vue&type=style&index=0&id=bfb07c60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports